import { createSchoolApi } from "@/components/school/SchoolHub";
import { getToken } from "@/lib/api";

// One shared client for the School page and the nav's "is this a school account?" check. It talks to the
// platform gateway directly (the school lives there, not in this app), with the same sign-in token.
export const schoolApi = createSchoolApi({ gatewayUrl: process.env.REACT_APP_GATEWAY_URL, getToken });
